// @ts-nocheck THIS FILE IS GENERATED, DO NOT EDIT!
import * as Types from 'generated/graphql-types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type GetFeatureFlagQueryVariables = Types.Exact<{
  featureFlagId: Types.Scalars['String']['input'];
}>;


export type GetFeatureFlagQuery = { featureFlag?: { id?: string, key: string, description?: string, displayName?: string, global?: boolean, usersCount?: unknown, disabledMessage?: string, enabled?: boolean, from?: string, propertiesJson?: string, to?: string, version?: number } };

export type FeatureFlagDetailsFragment = { id?: string, key: string, description?: string, displayName?: string, global?: boolean, usersCount?: unknown, disabledMessage?: string, enabled?: boolean, from?: string, propertiesJson?: string, to?: string, version?: number };

export type GetFeatureFlagsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetFeatureFlagsQuery = { featureFlags?: Array<{ id?: string, key: string, description?: string, displayName?: string, global?: boolean, usersCount?: unknown, disabledMessage?: string, enabled?: boolean, from?: string, propertiesJson?: string, to?: string, version?: number }> };

export type DeleteFeatureFlagMutationVariables = Types.Exact<{
  featureFlagId: Types.Scalars['String']['input'];
}>;


export type DeleteFeatureFlagMutation = { deleteFeatureFlag?: { id?: string, key: string, description?: string, displayName?: string, global?: boolean, usersCount?: unknown, disabledMessage?: string, enabled?: boolean, from?: string, propertiesJson?: string, to?: string, version?: number } };

export type UpsertFeatureFlagMutationVariables = Types.Exact<{
  featureFlag: Types.FeatureFlagInput;
}>;


export type UpsertFeatureFlagMutation = { upsertFeatureFlag?: { id?: string, key: string, description?: string, displayName?: string, global?: boolean, usersCount?: unknown, disabledMessage?: string, enabled?: boolean, from?: string, propertiesJson?: string, to?: string, version?: number } };

export const FeatureFlagDetailsFragmentDoc = gql`
    fragment FeatureFlagDetails on FeatureFlag {
  id
  key
  description
  displayName
  global
  usersCount
  disabledMessage
  enabled
  from
  propertiesJson
  to
  version
}
    `;
export const GetFeatureFlagDocument = gql`
    query GetFeatureFlag($featureFlagId: String!) {
  featureFlag(id: $featureFlagId) {
    ...FeatureFlagDetails
  }
}
    ${FeatureFlagDetailsFragmentDoc}`;

/**
 * __useGetFeatureFlagQuery__
 *
 * To run a query within a React component, call `useGetFeatureFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureFlagQuery({
 *   variables: {
 *      featureFlagId: // value for 'featureFlagId'
 *   },
 * });
 */
export function useGetFeatureFlagQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFeatureFlagQuery, GetFeatureFlagQueryVariables> & ({ variables: GetFeatureFlagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>(GetFeatureFlagDocument, options);
      }
export function useGetFeatureFlagLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>(GetFeatureFlagDocument, options);
        }
// @ts-ignore
export function useGetFeatureFlagSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>;
export function useGetFeatureFlagSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetFeatureFlagQuery | undefined, GetFeatureFlagQueryVariables>;
export function useGetFeatureFlagSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>(GetFeatureFlagDocument, options);
        }
export type GetFeatureFlagQueryHookResult = ReturnType<typeof useGetFeatureFlagQuery>;
export type GetFeatureFlagLazyQueryHookResult = ReturnType<typeof useGetFeatureFlagLazyQuery>;
export type GetFeatureFlagSuspenseQueryHookResult = ReturnType<typeof useGetFeatureFlagSuspenseQuery>;
export type GetFeatureFlagQueryResult = ApolloReactCommon.QueryResult<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>;
export const GetFeatureFlagsDocument = gql`
    query GetFeatureFlags {
  featureFlags {
    ...FeatureFlagDetails
  }
}
    ${FeatureFlagDetailsFragmentDoc}`;

/**
 * __useGetFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useGetFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeatureFlagsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>(GetFeatureFlagsDocument, options);
      }
export function useGetFeatureFlagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>(GetFeatureFlagsDocument, options);
        }
// @ts-ignore
export function useGetFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>;
export function useGetFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetFeatureFlagsQuery | undefined, GetFeatureFlagsQueryVariables>;
export function useGetFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>(GetFeatureFlagsDocument, options);
        }
export type GetFeatureFlagsQueryHookResult = ReturnType<typeof useGetFeatureFlagsQuery>;
export type GetFeatureFlagsLazyQueryHookResult = ReturnType<typeof useGetFeatureFlagsLazyQuery>;
export type GetFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useGetFeatureFlagsSuspenseQuery>;
export type GetFeatureFlagsQueryResult = ApolloReactCommon.QueryResult<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>;
export const DeleteFeatureFlagDocument = gql`
    mutation DeleteFeatureFlag($featureFlagId: String!) {
  deleteFeatureFlag(featureFlagId: $featureFlagId) {
    ...FeatureFlagDetails
  }
}
    ${FeatureFlagDetailsFragmentDoc}`;
export type DeleteFeatureFlagMutationFn = ApolloReactCommon.MutationFunction<DeleteFeatureFlagMutation, DeleteFeatureFlagMutationVariables>;

/**
 * __useDeleteFeatureFlagMutation__
 *
 * To run a mutation, you first call `useDeleteFeatureFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeatureFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeatureFlagMutation, { data, loading, error }] = useDeleteFeatureFlagMutation({
 *   variables: {
 *      featureFlagId: // value for 'featureFlagId'
 *   },
 * });
 */
export function useDeleteFeatureFlagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteFeatureFlagMutation, DeleteFeatureFlagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteFeatureFlagMutation, DeleteFeatureFlagMutationVariables>(DeleteFeatureFlagDocument, options);
      }
export type DeleteFeatureFlagMutationHookResult = ReturnType<typeof useDeleteFeatureFlagMutation>;
export type DeleteFeatureFlagMutationResult = ApolloReactCommon.MutationResult<DeleteFeatureFlagMutation>;
export type DeleteFeatureFlagMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteFeatureFlagMutation, DeleteFeatureFlagMutationVariables>;
export const UpsertFeatureFlagDocument = gql`
    mutation UpsertFeatureFlag($featureFlag: FeatureFlagInput!) {
  upsertFeatureFlag(featureFlag: $featureFlag) {
    ...FeatureFlagDetails
  }
}
    ${FeatureFlagDetailsFragmentDoc}`;
export type UpsertFeatureFlagMutationFn = ApolloReactCommon.MutationFunction<UpsertFeatureFlagMutation, UpsertFeatureFlagMutationVariables>;

/**
 * __useUpsertFeatureFlagMutation__
 *
 * To run a mutation, you first call `useUpsertFeatureFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertFeatureFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertFeatureFlagMutation, { data, loading, error }] = useUpsertFeatureFlagMutation({
 *   variables: {
 *      featureFlag: // value for 'featureFlag'
 *   },
 * });
 */
export function useUpsertFeatureFlagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertFeatureFlagMutation, UpsertFeatureFlagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertFeatureFlagMutation, UpsertFeatureFlagMutationVariables>(UpsertFeatureFlagDocument, options);
      }
export type UpsertFeatureFlagMutationHookResult = ReturnType<typeof useUpsertFeatureFlagMutation>;
export type UpsertFeatureFlagMutationResult = ApolloReactCommon.MutationResult<UpsertFeatureFlagMutation>;
export type UpsertFeatureFlagMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertFeatureFlagMutation, UpsertFeatureFlagMutationVariables>;